import classNames from 'classnames'
import { ReactNode } from 'react'

export const CardContainer = (props: {
  children: ReactNode
  className?: string
  variant?: 'grid' | 'flex'
}) => {
  const flexVariant = 'flex flex-row flex-wrap m-0 mb-6 gap-5'
  const gridVariant =
    ' max-w-[2000px] mx-auto grid gap-4 grid-cols-1 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-12 2xl:grid-cols-[repeat(16,_minmax(0,_1fr))] grid-flow-dense auto-rows-[100px]'
  return (
    <div
      className={classNames(props.variant == 'flex' ? flexVariant : gridVariant, props.className)}
    >
      {props.children}
    </div>
  )
}
